import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { OrderEntity } from "../../Objects/Order/OrderEntity"
import { GetRequest } from "../../services/ApiClientService"
import { useTranslation } from "react-i18next"

export const useGetTableOpenOrders = () => {
  const { t } = useTranslation("general")

  const { setError } = useError()

  const handleGetTableOpenOrders = async (tableId: number, onSuccess: (orders: OrderEntity[]) => void) => {
    try {
      const response = await GetRequest<OrderEntity[]>(API_ROUTES.ORDER.GET_OPEN_BY_TABLE(tableId))

      if (response.success) {
        const orders = response.data?.map((order) => new OrderEntity(order)) ?? []

        onSuccess(orders)

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    }
  }

  return {
    handleGetTableOpenOrders,
  }
}
